import React from 'react';
import { Card, CardContent } from '@/shared/ui/card';
import { Button } from '@/shared/ui/button';
import { Plus } from '../../../../shared/assets/AppIcons';

export default function EmptyAssignmentsState({
  icon: Icon,
  title,
  description,
  showButton = false,
  onCreate,
}) {
  return (
    <Card className="assignment-empty-state">
      <CardContent className="assignment-empty-state__content">
        <Icon className="assignment-empty-state__icon" size={32} />
        <p className="assignment-empty-state__title">{title}</p>
        <p className="assignment-empty-state__description">{description}</p>

        {showButton ? (
          <Button
            className="wt-primary-action-button"
            onClick={onCreate}
          >
            <Plus size={16} className="mr-2" />
            Crea il primo task
          </Button>
        ) : null}
      </CardContent>
    </Card>
  );
}
